import { useTranslation } from "react-i18next";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { ShowAllOptionsButtonProps } from "../types";
import { StyledButton } from "./ShowAllOptionsButton.styles";

// Shows or hides the candidates hidden by default. While they are hidden, the label gives their number.
const ShowAllOptionsButton = ({
    controlsId,
    handleToggle,
    hiddenCount,
    isExpanded,
}: ShowAllOptionsButtonProps) => {
    const { t } = useTranslation();

    const theme = window.env.REACT_APP_THEME;
    const label = isExpanded
        ? t(`seeLess.${theme}`)
        : `${t(`seeMore.${theme}`)} (${hiddenCount})`;
    const icon = isExpanded ? (
        <ExpandLessIcon aria-hidden="true" />
    ) : (
        <ExpandMoreIcon aria-hidden="true" />
    );

    return (
        <StyledButton
            type="button"
            aria-expanded={isExpanded}
            aria-controls={controlsId}
            onClick={handleToggle}
        >
            {icon}
            <span>{label}</span>
        </StyledButton>
    );
};

export default ShowAllOptionsButton;
